import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { TOTAL_ROWS_COUNT_CLASS_NAME } from '../classNames';
import { type PaginationProps, type TablePaginationActionsProps } from './types';
import { StyledTablePagination, StyledPaginationActions, StyledPageIndex } from './styles';
import Button from '../../Button';
import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon';
import { ArrowRightIcon } from '../../icons/ArrowRightIcon';
import { Typography } from '@mui/material';
export function TablePaginationActions(props) {
  const $ = _c(21);
  const {
    count,
    page,
    rowsPerPage,
    onPageChange,
    shouldDisableNextButton,
    shouldShowPageNumber
  } = props;
  let t0;
  if ($[0] !== onPageChange || $[1] !== page) {
    t0 = event => {
      onPageChange(event, page - 1);
    };
    $[0] = onPageChange;
    $[1] = page;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleBackButtonClick = t0;
  let t1;
  if ($[3] !== onPageChange || $[4] !== page) {
    t1 = event_0 => {
      onPageChange(event_0, page + 1);
    };
    $[3] = onPageChange;
    $[4] = page;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleNextButtonClick = t1;
  const t2 = page === 0;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowLeftIcon />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleBackButtonClick || $[8] !== t2) {
    t4 = <Button onClick={handleBackButtonClick} variant="text" disabled={t2} leftIcon={t3} aria-label="previous page" />;
    $[7] = handleBackButtonClick;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== page || $[11] !== shouldShowPageNumber) {
    t5 = shouldShowPageNumber && <StyledPageIndex><Typography variant="body2">{page + 1}</Typography></StyledPageIndex>;
    $[10] = page;
    $[11] = shouldShowPageNumber;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = shouldDisableNextButton ?? page >= Math.ceil(count / rowsPerPage) - 1;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArrowRightIcon />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handleNextButtonClick || $[15] !== t6) {
    t8 = <Button onClick={handleNextButtonClick} variant="text" disabled={t6} leftIcon={t7} aria-label="next page" />;
    $[14] = handleNextButtonClick;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t8) {
    t9 = <StyledPaginationActions>{t4}{t5}{t8}</StyledPaginationActions>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
export const TablePagination = t0 => {
  const $ = _c(20);
  let props;
  let shouldDisableNextButton;
  let t1;
  let t2;
  let t3;
  let totalCount;
  if ($[0] !== t0) {
    ({
      totalCount,
      shouldDisableNextButton,
      rowsPerPageLabel: t1,
      shouldShowPageNumber: t2,
      inScrollingContainer: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = shouldDisableNextButton;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = totalCount;
  } else {
    props = $[1];
    shouldDisableNextButton = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    totalCount = $[6];
  }
  const rowsPerPageLabel = t1 === undefined ? "Rows per page" : t1;
  const shouldShowPageNumber = t2 === undefined ? false : t2;
  const inScrollingContainer = t3 === undefined ? false : t3;
  let t4;
  if ($[7] !== totalCount) {
    t4 = t5 => {
      const {
        from,
        to,
        count
      } = t5;
      if (totalCount != null && totalCount > count) {
        return [<span key="fromTo">{`${from} – ${to} of ${count}`}</span>, <span className={TOTAL_ROWS_COUNT_CLASS_NAME} key="total">{` (Total ${totalCount})`}</span>];
      }
      return `${from} – ${to} of ${count}`;
    };
    $[7] = totalCount;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const labelDisplayedRows = t4;
  let t5;
  if ($[9] !== shouldDisableNextButton || $[10] !== shouldShowPageNumber || $[11] !== totalCount) {
    t5 = subprops => <TablePaginationActions {...subprops} totalCount={totalCount} shouldDisableNextButton={shouldDisableNextButton} shouldShowPageNumber={shouldShowPageNumber} />;
    $[9] = shouldDisableNextButton;
    $[10] = shouldShowPageNumber;
    $[11] = totalCount;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      IconComponent: _temp
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== inScrollingContainer || $[15] !== labelDisplayedRows || $[16] !== props || $[17] !== rowsPerPageLabel || $[18] !== t5) {
    t7 = <StyledTablePagination component="div" ActionsComponent={t5} labelDisplayedRows={labelDisplayedRows} labelRowsPerPage={rowsPerPageLabel} inScrollingContainer={inScrollingContainer} SelectProps={t6} {...props} />;
    $[14] = inScrollingContainer;
    $[15] = labelDisplayedRows;
    $[16] = props;
    $[17] = rowsPerPageLabel;
    $[18] = t5;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export { TABLE_PAGINATION_HEIGHT } from './constants';
export default TablePagination;
function _temp() {
  return null;
}